module.exports = __webpack_public_path__ + "static/media/5040.0000ddd8.jpg";